<template>
<li>
  <a @click="select(item)">
    <span v-text="_trans(item.des)"></span>
    <span v-if="item.data" class="arrow" v-bind:class="{ 'dropdown-open': open, 'dropdown-close': !open }"></span>
  </a>
  <ul class="dropdown" v-if="(item.data  && item.data.length > 0) && open">
    <d-menuitem v-for="(item, i) in item.data" :key="i" :item="item"></d-menuitem>
  </ul>
</li>
</template>

<script>
import { Dau, bus } from "@store/dau"
export default {
  props: {
    active: { type: Boolean, default: false },
    item: {
        type: Object,
        default() {
          return { des: '**no description**'};
      }
    },
    navigate: Function
  },

  data() {
     return {
        open: false
     }
  },
  computed: {

  },
  created() {
      let self = this;
      document.addEventListener('click',this.onclick);
      document.addEventListener('touchstart',this.onclick);

      // Close dropdown
      bus.$on("closedropdown", e => {
          console.log(this.open);
          this.open = false;
      });
  },
  beforeDestroy() {
      document.removeEventListener('click',this.onclick);
      document.removeEventListener('touchstart',this.onclick);
      bus.$off("closedropdown");
  },
  methods: {
      onclick(e) {
          if (e.srcElement.classList[0]=='menu') {
              if (e.srcElement.parentNode.parentNode===this.$el || e.srcElement.parentNode===this.$el || e.srcElement===this.$el) {
                  if (this.items && this.items.length>0) {
                      this.open=true;
                  } else {
                      this.select({des:this.title,cod:this.cod});
                  }
              } else {
                  this.open=false;
              }
              this.$forceUpdate();
          } else if (this.open) {
              this.open = false;
              this.$forceUpdate();

          }
        },
    select(item) {
      if(item.submenu && item.submenu.length > 0){
        this.tolggleSubmenu();
      }
      if (item.cod) {
        this.navigate(item);
//        this.$emit("navigate", item.cod);
      }
    },
    tolggleSubmenu() {
        this.open = !this.open;
    }
    ,
    closeSubmenu() {
//          alert();
        this.open = false;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/_eng/globals/dmenuItem.vue